import { render, staticRenderFns } from "./PfdoIcon.vue?vue&type=template&id=8a9279d2"
import script from "./PfdoIcon.vue?vue&type=script&lang=js"
export * from "./PfdoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports